<template>
  <v-container fluid class="pa-0 bg-slate-50 min-h-screen" style="font-family: 'Inter', sans-serif;">
    <div class="p-4 md:p-8">
      <div class="max-w-4xl mx-auto">
        
        <!-- HEADER -->
        <div class="mb-8 flex items-center justify-between">
          <div>
            <h1 class="text-2xl font-bold text-slate-700 tracking-tight">Item da Licitação</h1>
            <p class="text-sm text-slate-500 font-medium italic">{{ id ? 'Editando informações do item' : 'Cadastrando novo item/proposta na licitação' }}</p>
          </div>
            <button 
              @click="$router.push({ path: `/parts-and-services/biddings-manager/edit/${b_id}`, query: { tab: 2 } })"
              class="flex items-center gap-2 text-slate-500 hover:text-orange-600 transition-all mb-2 group"
            >
              <v-icon small color="currentColor" class="transition-transform group-hover:-translate-x-1">mdi-arrow-left</v-icon>
              <span class="text-[10px] font-black uppercase tracking-[0.2em]">Voltar</span>
            </button>
        </div>

        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="space-y-6">
            
            <!-- SEÇÃO: DADOS DO ITEM -->
            <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div class="px-6 py-3 flex items-center gap-3" style="background-color: #333333;">
                <v-icon color="orange" small>mdi-package-variant-closed</v-icon>
                <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">INFORMAÇÕES DO ITEM</h2>
              </div>
              
              <div class="p-6">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
                  <!-- Número -->
                  <div class="md:col-span-3">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Número do Item</label>
                    <v-text-field
                      v-model="data.item_number"
                      v-mask-number
                      placeholder="0"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Nome -->
                  <div class="md:col-span-6">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Nome / Descrição</label>
                    <v-text-field
                      v-model="data.name"
                      :rules="fieldRules"
                      placeholder="NOME DO ITEM..."
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Origem -->
                  <div class="md:col-span-3">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Origem</label>
                    <v-autocomplete
                      v-model="data.origem"
                      :items="[{ value: 'Nacional' }, { value: 'Importado' }]"
                      item-value="value"
                      item-text="value"
                      placeholder="SELECIONE..."
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Marca -->
                  <div class="md:col-span-4">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Marca</label>
                    <v-text-field
                      v-model="data.marca"
                      placeholder="MARCA..."
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Modelo -->
                  <div class="md:col-span-4">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Modelo</label>
                    <v-text-field
                      v-model="data.modelo"
                      placeholder="MODELO..."
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Validade -->
                  <div class="md:col-span-4">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Data de Validade</label>
                    <v-text-field
                      v-model="data.validity"
                      v-mask-date.br
                      placeholder="DD/MM/AAAA"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Quantidade -->
                  <div class="md:col-span-4">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Quantidade Total</label>
                    <v-text-field
                      v-model="data.quantidade"
                      v-mask-number
                      placeholder="0"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Qtd Mínima -->
                  <div class="md:col-span-4">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Quantidade Mínima</label>
                    <v-text-field
                      v-model="data.qtd_minima"
                      v-mask-number
                      placeholder="0"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Disponível -->
                  <div class="md:col-span-4">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Quantidade Disponível</label>
                    <v-text-field
                      v-model="data.restante"
                      v-mask-number
                      placeholder="0"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Preço Unitário -->
                  <div class="md:col-span-4">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Preço Unitário</label>
                    <v-text-field
                      v-model="data.item_price"
                      v-mask-decimal.br
                      placeholder="R$ 0,00"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Participante -->
                  <div class="md:col-span-12">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Fornecedor Participante</label>
                    <div class="flex gap-2">
                      <v-autocomplete
                        v-model="data.provider_id"
                        :items="providers"
                        item-value="provider_id"
                        item-text="provider_name"
                        :rules="fieldRules"
                        placeholder="SELECIONE O FORNECEDOR..."
                        solo flat dense hide-details
                        class="custom-select flex-grow"
                      />
                      <v-btn 
                        @click="$router.push('/parts-and-services/providers-manager/create')"
                        color="orange"
                        dark
                        elevation="0"
                        class="rounded h-[48px] min-w-[48px] px-0"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- BOTÕES DE AÇÃO -->
            <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div class="bg-slate-50 px-8 py-5 flex justify-end items-center gap-4">
                <button 
                  @click="$router.push({ path: `/parts-and-services/biddings-manager/edit/${b_id}`, query: { tab: 2 } })"
                  class="text-slate-500 hover:text-slate-700 font-bold text-[11px] uppercase px-4 py-2 transition-colors flex-none"
                >
                  Cancelar
                </button>
                <div class="flex-none">
                  <button
                    @click="validate"
                    :disabled="!valid || loader"
                    class="bg-orange-500 hover:bg-orange-600 text-white font-bold text-[11px] px-6 py-2.5 rounded shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all w-auto max-w-max whitespace-nowrap flex items-center gap-2"
                  >
                    <v-icon small color="white" class="mr-1" style="font-size: 14px;">mdi-check</v-icon>
                    <span v-if="loader" class="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></span>
                    <span v-else>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
                  </button>
                </div>
              </div>
            </section>

          </div>
        </v-form>
      </div>
    </div>

    <!-- NOTIFICAÇÕES -->
    <v-snackbar multi-line border="left" :color="snack.color" v-model="snack.show" transition="scroll-y-reverse-transition" class="mb-6">
      <div class="flex items-center gap-3">
        <v-icon color="white">mdi-information-outline</v-icon>
        <span class="font-bold text-xs uppercase tracking-wider">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import helpers from "@/mixins/helpers";
export default {
  props: ["b_id", "id"],
  mixins: [helpers],
  data: () => ({
    valid: false,
    loader: false,
    providers: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      item_id: null,
      provider_id: null,
      prefecture_id: null,
      bidding_id: null,
      item_number: null,
      name: "",
      origem: null,
      marca: "",
      modelo: "",
      quantidade: null,
      restante: null,
      validity: "",
      qtd_minima: null,
      item_price: 0,
      item_billing_price: 0,
    },
  }),
  created() {
    this.$http
      .get(`/parts-and-services/providers`)
      .then((r) => (this.providers = r.data));
    this.$http
      .get(`/parts-and-services/biddings/${this.b_id}`)
      .then((r) => (this.data.prefecture_id = r.data[0].prefecture_id));

    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http
        .post(`/parts-and-services/biddings/items/single/item/${this.id}`)
        .then((r) => {
          this.data = r.data[0];
          // Converter data de validade do formato ISO para DD/MM/AAAA
          if (this.data.validity) {
            this.data.validity = this.formatDateBr(this.data.validity);
          }
          // Formatar preço para exibição
          if (this.data.item_price != null) {
            this.data.item_price = this.realMask(String(this.data.item_price));
          }
          this.$store.dispatch("setLoader", false);
        });
    } else {
      this.data.bidding_id = Number(this.b_id);
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "Atenção um ou mais campos precisam ser preenchidos!";
      }
    },
    createOrUpdate() {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      
      const method = this.id ? 'put' : 'post';
      const url = this.id ? `/parts-and-services/biddings/items/${this.id}` : "/parts-and-services/biddings/items";
      
      if (!this.id) this.data.item_billing_price = this.data.item_price;

      // Enviar apenas os campos da tabela de itens (sem campos extras do JOIN)
      const payload = {
        item_id: this.data.item_id,
        provider_id: this.data.provider_id,
        prefecture_id: this.data.prefecture_id,
        bidding_id: this.data.bidding_id,
        item_number: this.data.item_number,
        name: this.data.name,
        origem: this.data.origem,
        marca: this.data.marca,
        modelo: this.data.modelo,
        quantidade: this.data.quantidade,
        restante: this.data.restante,
        validity: this.data.validity,
        qtd_minima: this.data.qtd_minima,
        item_price: typeof this.data.item_price === 'string' 
          ? this.convertStringNumber(this.data.item_price) 
          : this.data.item_price,
        item_billing_price: typeof this.data.item_billing_price === 'string' 
          ? this.convertStringNumber(this.data.item_billing_price) 
          : this.data.item_billing_price,
      };

      this.$http[method](url, payload)
        .then((r) => {
          this.snack.show = true;
          this.snack.message = r.data.result;
          this.snack.color = "success";
          setTimeout(() => {
            this.$router.push({ path: `/parts-and-services/biddings-manager/edit/${this.b_id}`, query: { tab: 2 } });
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
  },
};
</script>

<style scoped>
.custom-select ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  border-radius: 4px !important;
  height: 48px !important;
  padding: 0 16px !important;
}

.custom-select ::v-deep input {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #334155 !important;
  text-transform: uppercase !important;
}

.custom-select ::v-deep .v-label {
  font-size: 10px !important;
  font-weight: 900 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.15em !important;
  color: #94a3b8 !important;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
